import { createMultiStyleConfigHelpers as e } from "@chakra-ui/react";
const t = e(["container"]), r = t.defineMultiStyleConfig({
  baseStyle: {
    container: {
      bg: "white",
      px: "6",
      alignItems: "center",
      h: "60px",
      flexDir: "row",
      borderBottomWidth: "1px",
      borderBottomColor: "gray.200"
    }
  },
  variants: {},
  defaultProps: {}
});
export {
  r as default
};
